import { Dispatcher } from 'flux';

interface CurrencyDispatcher
  extends Dispatcher<{
    source: 'CURRENCY_DISPATCHER';
    action: any;
  }> {
  INSUFFICIENT_GOLD: 'INSUFFICIENT_GOLD';
  NEW_CURRENCY_BALANCE: 'NEW_CURRENCY_BALANCE';
  handleCurrencyAction: (action: any) => void;
}

const dispatcher = new Dispatcher();

export default Object.assign(dispatcher, {
  INSUFFICIENT_GOLD: 'INSUFFICIENT_GOLD',
  NEW_CURRENCY_BALANCE: 'NEW_CURRENCY_BALANCE',

  handleCurrencyAction: function (action: any) {
    dispatcher.dispatch({
      source: 'CURRENCY_DISPATCHER',
      action,
    });
  },
}) as CurrencyDispatcher;
